import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import CooperationEventModel from '../../../../model/cooperationEvent.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import EventService from '../../../../api/event/event.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import Pagination from '../../../../model/pagination';
import CooperationModel from '../../../../model/cooperation.model';
import {debounceTime, finalize, switchMap, tap} from 'rxjs/operators';
import CooperationService from '../../../../api/cooperation/cooperation.service';
import MediumModel from '../../../../model/medium.model';
import {
  CooperationDialogComponent,
  CooperationDialogModel
} from "../../../dialogs/cooperation-dialog/cooperation-dialog.component";
import CurrencyModel from "../../../../model/currency.model";
import {NgxMatDatetimepicker} from "@angular-material-components/datetime-picker";

@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss']
})
export class EventFormComponent implements OnInit, AfterViewInit {
  @Input() event: CooperationEventModel;
  @ViewChild('fileInput') fileInput: ElementRef;

  public cooperations$: Observable<Pagination<CooperationModel>>;
  public eventForm: FormGroup;

  private currency: CurrencyModel;

  public medias: MediumModel[];

  public cooperationsLoading = false;

  @ViewChild(NgxMatDatetimepicker) picker: NgxMatDatetimepicker<any>;

  constructor(private eventService: EventService, private fb: FormBuilder,
              public dialogRef: MatDialogRef<EventFormComponent>,
              private cooperationService: CooperationService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: EventFormDialogModel) { }

  ngOnInit(): void {

    this.event = this.data.event;
    this.medias = this.data.event.medias || [];

    if(!this.event.id) {
      this.event.changeable = true;
    }
    let disabled =  !this.event.changeable;

    this.eventForm = this.fb.group({
      title: [this.event.title],
      fee: [this.event.fee],
      currency: [this.event.currency],
      briefing: [this.event.briefing],
      coupon: [this.event.coupon],
      conditions: [this.event.conditions],
      profile: [this.event.profile],
      state: [this.event.state],
      cooperation: [{ value: this.event.cooperation, disabled: disabled }],
      socialContributionType: [{ value: this.event.socialContributionType, disabled: disabled }],
      accountingType: [{ value: this.event.accountingType, disabled: disabled }],
      deadline: [{ value: this.event.deadline, disabled: disabled }],
      fullday: [{ value: this.event.fullday, disabled: disabled }],
    });
  }

  addDocument() {
    this.fileInput.nativeElement.click();
  }

  removeDocument(document: MediumModel) {
    const index = this.medias.indexOf(document);
    if(index >= 0) {
      this.medias.splice(index, 1);
    }
  }

  ngAfterViewInit() {
    this.cooperations$ = this.eventForm
      .get('cooperation')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.cooperationsLoading = true),
        switchMap((value: string) => this.cooperationService.list(value)),
        finalize(() => {
          this.cooperationsLoading = false;
        })
      );
  }

  updateFee(fee) {
    this.eventForm.get('fee').setValue(fee);
  }

  updateCurrency(currency: CurrencyModel) {
    this.currency = currency;
  }

  showPicker() {
    this.picker.open();
  }

  save() {
    const data = this.eventForm.getRawValue() as CooperationEventModel;
    if(this.currency) {
      data.currency = this.currency;
    }
    data.medias = this.medias;
    if(this.event?.id) {
      data['id'] = this.event.id;
    }
    if (data.id) {
      this.eventService.update(data).subscribe(result => {
        this.dialogRef.close(data);
      });
    } else {
      this.eventService.create(data).subscribe(result => {
        if(result) {
          this.dialogRef.close(result);
        }
      });
    }

  }

  displayCooperationFn(cooperation: CooperationModel) {
    if (cooperation) {
      return cooperation.name;
    }
  }

  addNewCooperation() {
    const dialogData = {
      cooperation: {
        state: 'draft',
        events: []
      }
    } as CooperationDialogModel;

    const dialogRef = this.dialog.open(CooperationDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult) {
        this.eventForm.get('cooperation').setValue(dialogResult);
      }
    });
  }

  filesSelected(event) {
    const files = event.target.files;
    for(let file of files) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        console.log(file);
        this.medias.push({
          filename: file.name,
          file: {
            data: reader.result.toString(),
            name: file.name
          },

          position: 0,
        });
      };
    }

    /**/
  }
}

export class EventFormDialogModel {
  constructor(public event: CooperationEventModel) {
  }
}
